import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  display: grid; 
  grid-template-columns: 1fr; 
  grid-template-rows: 1fr 9fr; 
  gap: 5px; 
  padding-block: 10px;
  padding-inline: 30px;
  grid-template-areas: 
    "Header"
    "Container"; 
  ;
`;

export const TitleContainer = styled.div`
  grid-area: Header;
`;

export const DepositContainer = styled.div`
  grid-area: Container;
  background-color: ${props => props.theme.colors.card};
  
  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 50px;
`;

export const InputContainer = styled.div`
  padding-block: 40px;
`;

export const Options = styled.div`
  display: flex;
  justify-content: space-around;
  padding-block: 20px
`;

export const Destino = styled.div`
  padding-block: 20px;
`;

export const Subtitle = styled.span`
  color: ${props => props.theme.colors.grey_text};
  margin-bottom: 3px;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;